import { useTranslation } from '@shared/core';
import { Invitation, Share, Website, Envelope, MailingAddress, Code } from '@withjoy/joykit/icons';
import React from 'react';
import { CustomizeNowButton } from '../../CustomizeNowButton';
import { InlineValueProps, ListValueProps } from '../ValueProps/ValueProps';
import type { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { MatchingFoilTemplate } from '../MatchingFoilTemplate';
import { useFeatureValue } from '@shared/core/featureFlags';

interface DigitalCustomizationPaneProps {
  themeId: string;
  category: StationeryTemplateCategoryEnum;
  onCustomizeClick: () => void;
  isCreatingDraft: boolean;
  intersectionRef: React.RefObject<HTMLButtonElement>;
  hideCustomizeNowButton?: boolean;
  disableCustomizeNowButton?: boolean;
}

export const DigitalCustomizationPane = (props: DigitalCustomizationPaneProps) => {
  const { disableCustomizeNowButton, onCustomizeClick, hideCustomizeNowButton, isCreatingDraft, intersectionRef, themeId, category } = props;
  const isFoilCrossSellEnabled = useFeatureValue('printEnableFoilCrossSellPdp').value === 'on';
  const { t2 } = useTranslation('stationery');

  const { inlineValueProps, listValueProps } = t2('pdpModal', 'customizationPane', 'digitalTemplateConfig');

  return (
    <>
      <CustomizeNowButton
        ref={intersectionRef}
        hide={hideCustomizeNowButton}
        isLoading={isCreatingDraft}
        onCustomizeClick={onCustomizeClick}
        disabled={disableCustomizeNowButton}
      />
      <InlineValueProps
        items={[
          { icon: <Website />, description: inlineValueProps.websiteDesign },
          { icon: <MailingAddress />, description: inlineValueProps.contactCollector },
          { icon: <Code />, description: inlineValueProps.delivery },
        ]}
      />
      <ListValueProps
        items={[
          {
            icon: <Website size={24} />,
            description: listValueProps.designs,
          },
          {
            icon: <Invitation size={24} />,
            description: listValueProps.tracking,
          },
          {
            icon: <Share size={24} />,
            description: listValueProps.contactCollector,
          },
          {
            icon: <Envelope size={24} />,
            description: listValueProps.linking,
          },
        ]}
        sectionTitle={listValueProps.sectionTitle}
      />
      {isFoilCrossSellEnabled && (
        <MatchingFoilTemplate
          category={category}
          themeId={themeId}
        />
      )}
    </>
  );
};
